import { Controller } from "@hotwired/stimulus"
import Choices from "choices.js"

// Progressively enhances UI::SelectComponent's native <select> with
// choices.js.
//
// data-controller lives on a wrapper div, not the <select> itself: choices.js
// reparents the select into its own generated wrapper on init, and if the
// controller were attached to the select, Stimulus's MutationObserver would
// see it get removed/re-added and reconnect the controller — which would
// reinitialize choices.js and reparent it again, looping forever and hanging
// the tab.
export default class extends Controller {
  static targets = ["select"]

  connect() {
    // choices.js only mirrors the page's direction (e.g. flipping the
    // dropdown caret to the left in RTL) when the select's own `dir` differs
    // from the document's computed direction — it never just inherits it.
    // Since this app's document is always RTL, that mismatch never happens
    // on its own, so it's set explicitly here.
    this.selectTarget.dir = document.documentElement.dir

    this.choices = new Choices(this.selectTarget, {
      searchEnabled: this.selectTarget.options.length > 8,
      itemSelectText: "",
      shouldSort: false,
    })
  }

  disconnect() {
    this.choices?.destroy()
  }
}
